export default "__VITE_ASSET__WUZacsdS__"